// src/polyfills-global.ts
(globalThis as any).global = globalThis;
